import authReducer, { IAuthState } from "../src/Page/LogIn/reducer";
import {
  foodReportInitialState,
  foodReportReducer,
} from "./container/FoodReport/FoodReportReducer";
import {
  orderReducer,
  OrderInitialState,
} from "./container/Order/OrderReducer";
import {
  categoryReducer,
  CategoryInitialState,
} from "./container/category/CategoryReducer";
import {
  companyReducer,
  CompanyInitialState,
} from "./container/Company/CompanyReducer";
import { foodReducer, FoodInitialState } from "./container/Food/FoodReducer";
import {
  activeMenuReducer,
  ActiveMenuInitialState,
} from "./container/Menu/activeMenuReducer";
import { userReducer, UserInitialState } from "./container/user/UserReducer";
import { roleReducer, RoleInitialState } from "./container/Role/RoleReducer";
import {
  PermissionInitialState,
  permissionReducer,
} from "./container/permission/permissionReducer";
import { menuInitialState, menuReducer } from "./container/Menu/MenuReducer";
import {
  complainInitialState,
  complainReducer,
} from "./container/Complain/ComplainReducer";
import { vatReducer, vatInitialState } from "./container/VAT/vatReducer";
import {
  AdminUserInitialState,
  adminUserReducer,
} from "./container/AdminUser/AdminUserReducer";
import { SCmpUserReportReducer, SCmpUserReportInitialState } from "./container/SCmpUserReport/SCmpUserReport";
const reducer: any = {
  authReducer,
  categoryReducer,
  activeMenuReducer,
  roleReducer,
  permissionReducer,
  foodReducer,
  userReducer,
  companyReducer,
  foodReportReducer,
  menuReducer,
  orderReducer,
  complainReducer,
  vatReducer,
  adminUserReducer,
  SCmpUserReportReducer
};

export type IReducer = {
  authReducer: IAuthState;
  categoryReducer: typeof CategoryInitialState;
  activeMenuReducer: typeof ActiveMenuInitialState;
  roleReducer: typeof RoleInitialState;
  foodReducer: typeof FoodInitialState;
  foodReportReducer: typeof foodReportInitialState;
  userReducer: typeof UserInitialState;
  companyReducer: typeof CompanyInitialState;
  permissionReducer: typeof PermissionInitialState;
  menuReducer: typeof menuInitialState;
  orderReducer: typeof OrderInitialState;
  complainReducer: typeof complainInitialState;
  vatReducer: typeof vatInitialState;
  adminUserReducer: typeof AdminUserInitialState;
  SCmpUserReportReducer: typeof SCmpUserReportInitialState
};
export default reducer;
